import { ViewChild } from '@angular/core';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthenService } from '../services/authen.service';
import { HttpService } from '../services/http.service';
import { HelperService } from '../services/helper.service';
import { NotifyService } from '../services/notify.service';
import { UrlParams } from '../helpers/url-params';
import * as AppConst from '../data/test.data';

export class MasterBase {
    @ViewChild('grid') grid;
    pageSettings: PageSettingsModel;
    gridData: DataManager;
    searchOpts: any = null;
    searchType: number = 0;
    searchValue: string = null;
    loading: boolean = false;

    get AppConst() { return AppConst; }

    constructor(public auth: AuthenService, protected http: HttpService, protected helper: HelperService, protected notify: NotifyService, protected translate: TranslateService) {
        this.pageSettings = { pageSize: 30 };
    }
}
